// reference columns -- this is for your reference
import type { ColumnDef, RowSelectionState } from '@tanstack/vue-table'
import { Button } from '~/components/ui/button'
import AlphabeticSortIcon from '~/components/AlphabeticSortIcon.vue'
import DataTableFilterableHeader from '~/components/ui/table/DataTableFilterableHeader.vue'
import { Checkbox } from '~/components/ui/checkbox'
import PreviewEsgMetricTableModal from '~/components/PreviewEsgMetricTableModal.vue'

export const createColumns = (topics: { id: string, title: string }[], rowSelection: Ref<RowSelectionState>): ColumnDef<EsgMetric>[] => [
  {
    accessorKey: 'name',
    id: 'name',
    size: 394,
    header: ({ column }) => {
      // 'asc', 'desc', or undefined
      const isSorted = column.getIsSorted()
      const sortIconStyling = isSorted === 'asc' ? 'text-green-500' : isSorted === 'desc' ? 'text-red-500 rotate-180' : ''

      return h('div', { class: 'flex justify-between items-center' }, [
        h('span', { class: 'text-sm text-slate-800 font-semibold capitalize' }, 'metric'),
        h(Button, {
          class: 'text-main-primary',
          variant: 'ghost',
          onClick: () => column.toggleSorting(isSorted === 'asc', true),
        }, () => h(AlphabeticSortIcon, { customStyle: `size-5 ${sortIconStyling}` })),
      ])
    },
    cell: ({ row, column }) => h('div', { class: 'flex items-center gap-4' }, [
      h(Checkbox, {
        'onUpdate:checked': (value: boolean) => {
          const rowId = row.original.id
          const newSelection = { ...rowSelection.value }
          if (value) {
            newSelection[rowId] = true
          }
          else {
            const newSelection = Object.fromEntries(
              Object.entries(rowSelection.value).filter(([key]) => key !== rowId),
            )
            rowSelection.value = newSelection
          }
          row.toggleSelected(!!value)
        },
      }),
      h('span', { class: 'text-md text-foreground truncate no-localize-translate' }, row.getValue(column.id)),
    ]),
  },
  {
    accessorKey: 'topic.title',
    id: 'topic',
    size: 280,
    header: ({ column }) => h(DataTableFilterableHeader, {
      column,
      title: 'topic',
      filterData: topics.map(topic => ({ id: topic.id, name: topic.title })),
    }),
    cell: ({ row, column }) => h('div', { class: 'text-left text-md text-foreground' }, row.getValue(column.id)),
  },
  {
    id: 'actions',
    size: 30,
    header: () => h('span', { class: 'capitalize text-sm text-slate-800 font-semibold' }, 'actions'),
    cell: ({ row }) => h(PreviewEsgMetricTableModal, {
      metric: row.original,
    }),
  },
]
